import React from 'react';
import {Frequencies} from "../../../../../../models";
import {capitaliseFirst} from "../../../../../../assets/scripts/string-functions";
import MortgageForm from "../../../../../components/data-capture/MortgageForm";
import {nextPayScale1} from "../../../../../components/client/application/forms/sections/ApplicantEmploymentIncome";

function ApplicationForm({section, inExtWindow = true}) {
    let target = !!section.index ? section.applicant === 1 ? `applicant1.employmentIncome[${section.index}]` : `applicant2.employmentIncome[${section.index}]` : section.applicant === 1 ? `applicant1.income` : `applicant2.income`

    let questions = [
        {
            name: 'payFrequency',
            label: 'Pay Frequency',
            answer: {
                type: 'select',
                choices: [
                    Frequencies.WEEKLY, Frequencies.MONTHLY, Frequencies.FORTNIGHTLY
                ].map(it => ({
                    value: it,
                    text: capitaliseFirst(it.toLowerCase())
                }))
            },
            target: `${target}.payFrequency`
        },
        {
            name: 'usingBikAmount',
            label: 'Yearly BIK Amount',
            answer: {
                type: 'euro',
            },
            target: `${target}.usingBikAmount`
        },
        {
            name: 'usingAvcAmount',
            label: 'Yearly AVC Amount',
            answer: {
                type: 'euro',
            },
            target: `${target}.usingAvcAmount`
        },
        {
            name: 'usingShareSaveAmount',
            label: 'Yearly Share Save Amount',
            answer: {
                type: 'euro',
            },
            target: `${target}.usingShareSaveAmount`
        }
    ]
    if (section?.data?.publicSector) {
        questions.push(
            {
                name: 'nextPayScale1',
                label: 'Payscale + 1',
                answer: {
                    type: 'euro',
                },
                target: `${target}.nextPayScale1`
            },
            {
                name: 'nextPayScale2',
                label: 'Payscale + 2',
                answer: {
                    type: 'euro',
                },
                target: `${target}.nextPayScale2`
            },
            {
                name: 'nextPayScale3',
                label: 'Payscale + 3',
                answer: {
                    type: 'euro',
                },
                target: `${target}.nextPayScale3`
            }
        )
    }

    return <MortgageForm questions={questions} inExtWindow={inExtWindow}/>
}

export default ApplicationForm;